/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useEffect, useState} from 'react';
import {Helmet} from 'react-helmet-async';
import {
  Grid,
  TableCell,
  TableBody,
  IconButton,
  Typography as MuiTypography,
  Link,
} from '@mui/material';
import {FilterList as FilterListIcon} from '@mui/icons-material';
import {Delete} from '@mui/icons-material';

import {typeRoutes} from '../../types/typeIslandersMembers';
import {Breadcrumbs, Chip, Table, Tooltips} from '../../components';
import useAuth from '../../hooks/useAuth';
import queryString from 'query-string';

//style
import {
  Typography,
  Divider,
  StyledTableRow,
  StyledAction,
  StyledStack,
} from './DistributionLogs.style';
import {ColumnsType} from '../../types/typeTable';
import {
  renderDistributionLogsDateTime,
  renderDistributionLogsDetails,
  renderDistributionLogsResults,
  renderDistributionLogsStatus,
  renderEmail,
} from '../../utils/distribution-logs/DistributionLogs';
import {images} from '../../constants/image';
import {useNavigate, useSearchParams} from 'react-router-dom';
import TargetedTicketDistributionLogService from '../../services/TargetedTicketDistributionLog/targetedTicketDistributionLog.service';
import {StringIsNullOrEmptyOrUndefined} from '../../utils/helpers';
import {path} from '../../routes/path';
import {
  formatDate,
  formatDateTime,
  formatLocalDateFromUTCTime,
} from '../../utils';
import colors from '../../theme/colors';
import ModalFilter from './components/Modalfilter/ModalFilter';
import {every, isEmpty, omit, reduce} from 'lodash';
import {ColorType} from '../../types/typeChip';
import ModalInformation from './components/ModalInformation/ModalInformation';

export const DISTRIBUTION_PLATFORMS_CONSTANT = {
  ADMIN_PORTAL: '1',
  SFMC: '2',
};

export const DISTRIBUTION_PLATFORMS_OPTIONS = [
  {
    value: DISTRIBUTION_PLATFORMS_CONSTANT.ADMIN_PORTAL,
    key: 'Admin Portal',
  },
  {
    value: DISTRIBUTION_PLATFORMS_CONSTANT.SFMC,
    key: 'Salesforce Marketing Cloud (SFMC)',
  },
];

export const ISLANDER_MEMBERS_SELECTION_TYPE_CONSTANT = {
  SINGLE_SPECIFIC_MEMBER: '1',
  MULTIPLE_SPECIFIC_MEMBERS: '2',
};

export const ISLANDER_MEMBERS_SELECTION_TYPE_OPTIONS = [
  {
    label: 'Single specific member',
    value: ISLANDER_MEMBERS_SELECTION_TYPE_CONSTANT.SINGLE_SPECIFIC_MEMBER,
  },
  {
    label: 'Multiple specific members (CSV list)',
    value: ISLANDER_MEMBERS_SELECTION_TYPE_CONSTANT.MULTIPLE_SPECIFIC_MEMBERS,
  },
];

function DistributionLogs() {
  const formatTime = 'DD/MM/YYYY HH:mm';
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  // states
  const [order] = React.useState<'desc' | 'asc'>('desc');
  const [orderBy] = React.useState('orderFeaturedTicket');
  const [dense] = React.useState(false);
  const [focusId, setFocusId] = useState(null);
  const [isModalFilter, setIsModalFilter] = useState(false);
  const [dataSource, setDataSource] = useState<Array<any>>([]);
  const [totalPage, setTotalPage] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const searchParamsObject = queryString.parse(searchParams.toString());

  const BASE_DEFAULT_PARAMS = {
    _page: 0,
    _size: 10,
    _sort: 'updatedDateTime:desc',
  };

  const DEFAULT_PARAMS = {
    status_eq: searchParamsObject.status_eq ?? undefined,
    distributionplatform_eq:
      searchParamsObject?.distributionplatform_eq ?? undefined,
    email_eq: searchParamsObject?.email_eq ?? undefined,
    targetedMembershipId_eq:
      searchParamsObject?.targetedMembershipId_eq ?? undefined,
    targetedTicketId_eq: searchParamsObject?.targetedTicketId_eq ?? undefined,
    targetedTicketId_label:
      searchParamsObject?.targetedTicketId_label ?? undefined,
    sFMCDefinitionInstanceID_eq:
      searchParamsObject?.sFMCDefinitionInstanceID_eq ?? undefined,
    sFMCJourneyID_eq: searchParamsObject?.sFMCJourneyID_eq ?? undefined,
    sFMCJourneyActivityID_eq:
      searchParamsObject?.sFMCJourneyActivityID_eq ?? undefined,
    createdDateTime_gte: searchParamsObject?.createdDateTime_gte ?? undefined,
    createdDateTime_lte: searchParamsObject?.createdDateTime_lte ?? undefined,
    targetedMembershipType_eq:
      searchParamsObject?.targetedMembershipType_eq ?? undefined,
  };

  const DEFAULT_VALUE_FILTER = {
    distributionplatform_eq:
      searchParams.get('distributionplatform_eq') ??
      DISTRIBUTION_PLATFORMS_CONSTANT.ADMIN_PORTAL,
    email_eq: searchParams.get('email_eq') ?? '',
    targetedMembershipId_eq: searchParams.get('targetedMembershipId_eq') ?? '',
    targetedTicketId_eq: searchParams.get('targetedTicketId_eq') ?? '',
    sFMCDefinitionInstanceID_eq:
      searchParams.get('sFMCDefinitionInstanceID_eq') ?? '',
    sFMCJourneyID_eq: searchParams.get('sFMCJourneyID_eq') ?? '',
    sFMCJourneyActivityID_eq:
      searchParams.get('sFMCJourneyActivityID_eq') ?? '',
    createdDateTime_gte: searchParams.get('createdDateTime_gte') ?? '',
    createdDateTime_lte: searchParams.get('createdDateTime_lte') ?? '',
    targetedMembershipType_eq:
      searchParams.get('targetedMembershipType_eq') ?? '',
  };

  const [params, setParams] = useState({
    ...BASE_DEFAULT_PARAMS,
    ...DEFAULT_PARAMS,
  });
  const [valueFilter, setValueFilter] = useState(DEFAULT_VALUE_FILTER);
  const [valueFilterLabels, setValueFilterLabels] = useState<any>({});

  const [modalInformationData, setModalInformationData] = useState<
    any | undefined
  >();

  const columns: Array<ColumnsType> = [
    {
      dataIndex: 'ID',
      numeric: true,
      disablePadding: false,
      label: 'ID',
    },
    {
      dataIndex: 'CreatedDateTime',
      numeric: false,
      disablePadding: false,
      label: 'Distribution',
      helperText: 'Date & Time',
    },
    {
      dataIndex: 'email',
      numeric: false,
      disablePadding: false,
      label: 'Admin email',
      helperText: 'Executed this distribution',
    },
    {
      dataIndex: 'distributionDetails',
      numeric: false,
      disablePadding: false,
      label: 'Distribution details',
    },
    {
      dataIndex: 'status',
      numeric: false,
      disablePadding: false,
      label: 'Status',
    },
    {
      dataIndex: 'results',
      numeric: false,
      disablePadding: false,
      label: 'Results',
    },
    {
      dataIndex: '',
      numeric: false,
      disablePadding: false,
      label: '',
    },
  ];

  const checkAndRemoveDistributionPlatform = (
    newValueFilter?: any | undefined
  ) => {
    const localValueFilter = newValueFilter || valueFilter;
    const valueFilterWithoutPlatform = omit(
      localValueFilter,
      'distributionplatform_eq'
    );
    if (every(valueFilterWithoutPlatform, item => item === '')) {
      setParams(prevState => ({
        ...prevState,
        distributionplatform_eq: undefined,
      }));
    }
  };

  const handleSwitchDistributionPlatform = (
    newValueFilter?: any | undefined
  ) => {
    const localValueFilter = newValueFilter || valueFilter;
    if (
      (localValueFilter.sFMCDefinitionInstanceID_eq ||
        localValueFilter.sFMCJourneyActivityID_eq ||
        localValueFilter.sFMCJourneyID_eq) &&
      localValueFilter.distributionplatform_eq ===
        DISTRIBUTION_PLATFORMS_CONSTANT.ADMIN_PORTAL
    ) {
      setValueFilter(prevState => ({
        ...prevState,
        distributionplatform_eq: DISTRIBUTION_PLATFORMS_CONSTANT.SFMC,
      }));
    }
  };

  const handleSwitchIslanderMemberSelectionType = (
    newValueFilter?: any | undefined
  ) => {
    const localValueFilter = newValueFilter || valueFilter;
    if (
      localValueFilter.targetedMembershipId_eq &&
      valueFilter.targetedMembershipType_eq !==
        ISLANDER_MEMBERS_SELECTION_TYPE_CONSTANT.SINGLE_SPECIFIC_MEMBER
    ) {
      setValueFilter(prevState => ({
        ...prevState,
        targetedMembershipType_eq:
          ISLANDER_MEMBERS_SELECTION_TYPE_CONSTANT.SINGLE_SPECIFIC_MEMBER,
      }));
    } else if (
      !localValueFilter.targetedMembershipId_eq &&
      valueFilter.targetedMembershipType_eq
    ) {
      setValueFilter(prevState => ({
        ...prevState,
        targetedMembershipType_eq: '',
      }));
    }
  };

  useEffect(() => {
    handleSwitchDistributionPlatform();
    handleSwitchIslanderMemberSelectionType();
    checkAndRemoveDistributionPlatform();
  }, []);

  const onChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setParams(preState => ({
      ...preState,
      _page: newPage,
    }));
  };

  const onChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setParams(preState => ({
      ...preState,
      _page: 0,
      _size: parseInt(event.target.value, 10),
    }));
  };

  const renderAction = (row: any) => {
    const resultOfDistribution =
      row.result !== '' ? JSON.parse(row.result) : null;
    return (
      <StyledAction>
        {!StringIsNullOrEmptyOrUndefined(row.unsuccessfulCsv) && (
          <Typography
            variant="body2"
            color={colors.systemLink}
            fontWeight="bold"
            onClick={() => window.open(row.unsuccessfulCsv)}
          >
            <img src={images.icon_download} />
            Download details
          </Typography>
        )}
        {resultOfDistribution?.DistributedIntoPocketQty > 0 && (
          <Typography
            variant="body2"
            color={colors.systemLink}
            fontWeight="bold"
            onClick={() => {
              const createdDateTime_gte = formatDateTime(
                new Date(row.createdDateTime),
                formatTime
              );
              const createdDateTime_lte = formatDateTime(
                new Date(row.updatedDateTime),
                formatTime
              );
              const ticketId = row.targetedTicketId;
              navigate(
                `/${path.VOUCHER_TRANSACTION_HISTORY}?_page=0&_size=10&_sort=updatedDateTime%3Adesc&createdDatetime_gte=${createdDateTime_gte}&createdDatetime_lte=${createdDateTime_lte}&ticketId_eq=${ticketId}&redemptionPlatform_eq=4&redemptionPlatform_label=System`
              );
            }}
          >
            <img src={images.icon_eye} />
            View transactions
          </Typography>
        )}
      </StyledAction>
    );
  };

  const getDistributionLogsApiPayload = () =>
    reduce(
      Object.keys(params),
      (acc: any, paramName: string) => {
        if (!['targetedTicketId_label'].includes(paramName)) {
          acc[paramName] = params[paramName];
        }
        return acc;
      },
      {}
    );

  const getDistributionLogs = () => {
    setIsLoading(true);
    new TargetedTicketDistributionLogService()
      .getAll(getDistributionLogsApiPayload())
      .then(res => {
        if (res?.success && res?.code === 200) {
          setDataSource(res.data.items);
          setTotalPage(res.data.total);
          setIsLoading(false);
        } else {
          setDataSource([]);
          setIsLoading(false);
        }
      })
      .catch(e => {
        setDataSource([]);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setSearchParams(
      queryString.stringify({
        ...params,
      })
    );
    getDistributionLogs();
  }, [params]);

  const toggleModalFilter = () => {
    setIsModalFilter(!isModalFilter);
  };

  const handleClean = () => {
    setValueFilter(
      Object.keys(DEFAULT_VALUE_FILTER).reduce((acc: any, key: string) => {
        acc[key] =
          key === 'distributionplatform_eq'
            ? DISTRIBUTION_PLATFORMS_CONSTANT.ADMIN_PORTAL
            : '';
        return acc;
      }, {})
    );
    setParams(
      Object.keys(DEFAULT_PARAMS).reduce((acc: any, key: string) => {
        acc[key] = undefined;
        return acc;
      }, BASE_DEFAULT_PARAMS)
    );
  };

  const handleFilter = () => {
    const updatedParams: any = {
      _page: 0,
    };
    if (valueFilter?.distributionplatform_eq) {
      updatedParams.distributionplatform_eq =
        valueFilter?.distributionplatform_eq;
    }
    if (valueFilter?.email_eq) {
      updatedParams.email_eq = valueFilter?.email_eq;
    }
    updatedParams.sFMCDefinitionInstanceID_eq =
      valueFilter?.sFMCDefinitionInstanceID_eq || undefined;
    updatedParams.sFMCJourneyID_eq = valueFilter?.sFMCJourneyID_eq || undefined;
    updatedParams.sFMCJourneyActivityID_eq =
      valueFilter?.sFMCJourneyActivityID_eq || undefined;
    if (
      valueFilter?.createdDateTime_lte !== '' ||
      valueFilter?.createdDateTime_gte !== ''
    ) {
      let createdDateTime_lte = valueFilter?.createdDateTime_lte;
      let createdDateTime_gte = valueFilter?.createdDateTime_gte;
      if (createdDateTime_lte === '') {
        createdDateTime_lte = formatLocalDateFromUTCTime(
          createdDateTime_gte,
          formatTime
        ) as string;
      }
      if (createdDateTime_gte === '') {
        createdDateTime_gte = formatLocalDateFromUTCTime(
          createdDateTime_lte,
          formatTime
        ) as string;
      }
      updatedParams.createdDateTime_lte = createdDateTime_lte;
      updatedParams.createdDateTime_gte = createdDateTime_gte;
    }
    if (valueFilter?.targetedTicketId_eq) {
      updatedParams.targetedTicketId_eq = valueFilter?.targetedTicketId_eq;
      updatedParams.targetedTicketId_label =
        valueFilterLabels?.targetedTicketId_eq;
    }
    updatedParams.targetedMembershipType_eq =
      valueFilter?.targetedMembershipType_eq || undefined;
    updatedParams.targetedMembershipId_eq =
      valueFilter?.targetedMembershipId_eq || undefined;
    const updatedParamsWithoutDistributionPlatform = omit(updatedParams, [
      'distributionplatform_eq',
      '_page',
      '_size',
    ]);
    if (
      every(
        updatedParamsWithoutDistributionPlatform,
        param => param === undefined
      )
    ) {
      updatedParams.distributionplatform_eq = undefined;
    }
    setParams(prevState => ({
      ...prevState,
      ...updatedParams,
    }));
    toggleModalFilter();
  };

  const deleteSearchParams = key => {
    if (searchParams.has(key)) {
      searchParams.delete(key);
      setSearchParams(searchParams);
    }
  };

  const handleDeleteChip = (type: string) => {
    let newValueFilter;
    if (type === 'email_eq') {
      deleteSearchParams('email_eq');
      newValueFilter = {
        ...valueFilter,
        email_eq: '',
      };
      setParams(prevState => ({
        ...prevState,
        email_eq: undefined,
      }));
    }

    if (type === 'date') {
      deleteSearchParams('createdDateTime_lte');
      deleteSearchParams('createdDateTime_gte');
      newValueFilter = {
        ...valueFilter,
        createdDateTime_lte: '',
        createdDateTime_gte: '',
      };
      setParams(preState => ({
        ...preState,
        _page: 0,
        _size: 10,
        createdDateTime_lte: undefined,
        createdDateTime_gte: undefined,
      }));
    }

    if (type === 'targetedTicketId_eq') {
      deleteSearchParams('targetedTicketId_eq');
      deleteSearchParams('targetedTicketId_label');
      newValueFilter = {
        ...valueFilter,
        targetedTicketId_eq: '',
      };
      setValueFilterLabels({
        ...valueFilterLabels,
        targetedTicketId_eq: '',
      });
      setParams(preState => ({
        ...preState,
        _page: 0,
        _size: 10,
        targetedTicketId_eq: undefined,
        targetedTicketId_label: undefined,
      }));
    }

    if (type === 'targetedMembershipId_eq') {
      deleteSearchParams('targetedMembershipId_eq');
      newValueFilter = {
        ...valueFilter,
        targetedMembershipId_eq: '',
      };
      setParams(preState => ({
        ...preState,
        _page: 0,
        _size: 10,
        targetedMembershipId_eq: undefined,
      }));
      handleSwitchIslanderMemberSelectionType(newValueFilter);
    }

    if (type === 'sFMCDefinitionInstanceID_eq') {
      deleteSearchParams('sFMCDefinitionInstanceID_eq');
      newValueFilter = {
        ...valueFilter,
        sFMCDefinitionInstanceID_eq: '',
      };
      setParams(preState => ({
        ...preState,
        _page: 0,
        _size: 10,
        sFMCDefinitionInstanceID_eq: undefined,
        distributionplatform_eq:
          newValueFilter.sFMCJourneyActivityID_eq ||
          newValueFilter.sFMCJourneyID_eq
            ? preState.distributionplatform_eq
            : undefined,
      }));
      handleSwitchDistributionPlatform(newValueFilter);
    }

    if (type === 'sFMCJourneyID_eq') {
      deleteSearchParams('sFMCJourneyID_eq');
      newValueFilter = {
        ...valueFilter,
        sFMCJourneyID_eq: '',
      };
      setParams(preState => ({
        ...preState,
        _page: 0,
        _size: 10,
        sFMCJourneyID_eq: undefined,
        distributionplatform_eq:
          newValueFilter.sFMCDefinitionInstanceID_eq ||
          newValueFilter.sFMCJourneyActivityID_eq
            ? preState.distributionplatform_eq
            : undefined,
      }));
      handleSwitchDistributionPlatform(newValueFilter);
    }

    if (type === 'sFMCJourneyActivityID_eq') {
      deleteSearchParams('sFMCJourneyActivityID_eq');
      newValueFilter = {
        ...valueFilter,
        sFMCJourneyActivityID_eq: '',
      };
      setParams(preState => ({
        ...preState,
        _page: 0,
        _size: 10,
        sFMCJourneyActivityID_eq: undefined,
        distributionplatform_eq:
          newValueFilter.sFMCDefinitionInstanceID_eq ||
          newValueFilter.sFMCJourneyID_eq
            ? preState.distributionplatform_eq
            : undefined,
      }));
      handleSwitchDistributionPlatform(newValueFilter);
    }
    if (!isEmpty(newValueFilter)) {
      setValueFilter(newValueFilter);
    }
    checkAndRemoveDistributionPlatform(newValueFilter);
  };

  const renderSendExclusiveBannerOnB2CPlatforms = (actionData: any) => {
    return (
      <>
        Send exclusive banner on B2C platforms:{' '}
        <MuiTypography component="span" fontWeight="bolder">
          {{
            true: (
              <Link
                underline="hover"
                color={colors.systemLink}
                sx={{
                  cursor: 'pointer',
                }}
                onClick={() =>
                  setModalInformationData({
                    variant: 'showExclusiveBannerData',
                    data: actionData,
                  })
                }
              >
                Yes
              </Link>
            ),
            false: 'No',
          }?.[actionData?.showExclusiveB2CBanner] ?? '-'}
        </MuiTypography>
      </>
    );
  };

  const renderSendPushNotificationToOptedInMembers = (actionData: any) => {
    return (
      <>
        Send push notification to opted-in members:{' '}
        <MuiTypography component="span" fontWeight="bolder">
          {{
            true: (
              <Link
                underline="hover"
                color={colors.systemLink}
                sx={{
                  cursor: 'pointer',
                }}
                onClick={() =>
                  setModalInformationData({
                    variant: 'showPushedNotificationData',
                    data: actionData,
                  })
                }
              >
                Yes
              </Link>
            ),
            false: 'No',
          }?.[actionData?.pushNotification] ?? '-'}
        </MuiTypography>
      </>
    );
  };

  return (
    <React.Fragment>
      <Helmet title="Distribution logs" />

      <ModalInformation
        visible={modalInformationData?.data}
        onClose={() => setModalInformationData(undefined)}
        data={modalInformationData}
      />

      <ModalFilter
        visible={isModalFilter}
        onClose={toggleModalFilter}
        handleFilter={handleFilter}
        handleClean={handleClean}
        defaultValueFilter={DEFAULT_VALUE_FILTER}
        valueFilter={valueFilter}
        setValueFilter={setValueFilter}
        valueFilterLabels={valueFilterLabels}
        setValueFilterLabels={setValueFilterLabels}
      />

      <Grid justifyContent="space-between" container spacing={2} columns={16}>
        <Grid item xs={8}>
          <Typography variant="h3" gutterBottom>
            Distribution logs
          </Typography>

          <Breadcrumbs
            routes={[
              typeRoutes('Voucher', undefined, true),
              typeRoutes('Distribution logs', undefined, true),
            ]}
          />
        </Grid>
        <Grid
          item
          xs={8}
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          <StyledStack direction="row" flexWrap="wrap" gap={3} spacing={3}>
            {searchParams.get('email_eq') !== null && (
              <Chip
                label={`${searchParams.get('email_eq')}`}
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('email_eq');
                }}
              />
            )}

            {searchParams.get('sFMCDefinitionInstanceID_eq') !== null && (
              <Chip
                label={`${searchParams.get('sFMCDefinitionInstanceID_eq')}`}
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('sFMCDefinitionInstanceID_eq');
                }}
              />
            )}

            {searchParams.get('sFMCJourneyID_eq') !== null && (
              <Chip
                label={`${searchParams.get('sFMCJourneyID_eq')}`}
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('sFMCJourneyID_eq');
                }}
              />
            )}

            {searchParams.get('sFMCJourneyActivityID_eq') !== null && (
              <Chip
                label={`${searchParams.get('sFMCJourneyActivityID_eq')}`}
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('sFMCJourneyActivityID_eq');
                }}
              />
            )}

            {searchParams.get('createdDateTime_lte') !== null &&
              searchParams.get('createdDateTime_gte') !== null && (
                <Chip
                  label={`${formatDate(
                    searchParams.get('createdDateTime_gte'),
                    formatTime
                  )} -
                    ${formatDate(
                      searchParams.get('createdDateTime_lte'),
                      formatTime
                    )}`}
                  color={'default' as ColorType}
                  onDelete={() => {
                    handleDeleteChip('date');
                  }}
                />
              )}

            {searchParams.get('targetedTicketId_label') !== null && (
              <Chip
                label={`${searchParams.get('targetedTicketId_label')}`}
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('targetedTicketId_eq');
                }}
              />
            )}

            {searchParams.get('targetedMembershipId_eq') !== null && (
              <Chip
                label={`${searchParams.get('targetedMembershipId_eq')}`}
                color={'default' as ColorType}
                onDelete={() => {
                  handleDeleteChip('targetedMembershipId_eq');
                }}
              />
            )}
          </StyledStack>
          <Tooltips title="Filter list">
            <IconButton
              aria-label="Filter list"
              size="large"
              onClick={toggleModalFilter}
            >
              <FilterListIcon />
            </IconButton>
          </Tooltips>
        </Grid>
      </Grid>

      <Divider my={6} />

      <Table
        dataSource={dataSource}
        columns={columns}
        page={params._page}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        rowsPerPage={params._size}
        order={order}
        textNodata="No logs found"
        orderBy={orderBy}
        isLoading={isLoading}
        dense={dense}
        isMultiCheckbox={false}
        count={totalPage}
      >
        <TableBody>
          {dataSource?.map((row, index) => {
            return (
              <StyledTableRow
                hover
                role="checkbox"
                tabIndex={-1}
                key={index}
                onMouseEnter={() => setFocusId(row.id)}
                onMouseLeave={() => setFocusId(null)}
              >
                <TableCell>{row.id}</TableCell>
                <TableCell align="left">
                  {renderDistributionLogsDateTime(row.createdDateTime)}
                </TableCell>
                <TableCell align="left">{renderEmail(row)}</TableCell>
                <TableCell align="left">
                  {renderDistributionLogsDetails(row, '-', {
                    renderSendExclusiveBannerOnB2CPlatforms,
                    renderSendPushNotificationToOptedInMembers,
                  })}
                </TableCell>
                <TableCell align="left">
                  {renderDistributionLogsStatus(row)}
                </TableCell>
                <TableCell align="left">
                  {renderDistributionLogsResults(row)}
                </TableCell>
                <TableCell>{renderAction(row)}</TableCell>
              </StyledTableRow>
            );
          })}
        </TableBody>
      </Table>
    </React.Fragment>
  );
}

export default DistributionLogs;
